import { Pipe, PipeTransform } from '@angular/core';

import {
  snakeCaseToTitleCase,
  toCamelCase,
  toCapitalize,
} from '../util/string-transformation.utils';

export enum StringTransformationType {
  TO_CAMEL_CASE = 'toCamelCase',
  TO_UPPER_CASE = 'toUpperCase',
  CAPITALIZE = 'capitalize',
  SNAKE_TO_TITLE_CASE = 'snakeToTitleCase',
  // Add more transformation types as needed
}

@Pipe({
  name: 'stringTransformation',
  standalone: true,
})
export class StringTransformationPipe implements PipeTransform {
  transform(value :string, transformType :string) :string | null {
    if (typeof value !== 'string') return null;

    switch (transformType) {
      case StringTransformationType.TO_CAMEL_CASE:
        return toCamelCase(value);
      case StringTransformationType.TO_UPPER_CASE:
        return value.toUpperCase();
      case StringTransformationType.CAPITALIZE:
        return toCapitalize(value);
      case StringTransformationType.SNAKE_TO_TITLE_CASE:
        return snakeCaseToTitleCase(value);
      // Add more transformation cases as needed
      default:
        return value; // Return the original value if no valid transformType is provided
    }
  }
}
